import _initializerDefineProperty from "@babel/runtime-corejs3/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime-corejs3/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime-corejs3/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
import { action, observable, runInAction } from 'mobx';
import { AI_LEARNING_NAV } from '../../browse-constants';
import { BROWSE_TYPE } from '../../browse-constants';
import { SUBCATEGORY_NOT_IN_PERSONAL_PLAN } from '../../constants';
import { AggregatorNavItemType } from '../../events';
import { fetchAggregatorTopics } from '../../fetch-aggregator-topics';
import { MOST_POPULAR_SUBCATEGORY_IDS, fetchMostPopularTopicsForSubcategories } from '../../fetch-popular-topics';
import { useAiTopicsQuery } from '../../graphql/api-platform-graphql';
import { aiTopicIdsByCategory } from '../../utils/constants';
export let MobileNavStore = (_dec = observable.ref, _dec2 = observable.ref, _dec3 = observable.ref, _dec4 = observable.ref, _dec5 = observable.ref, _dec6 = observable.ref, _class = class MobileNavStore {
  constructor(lang, gettext) {
    _initializerDefineProperty(this, "maxLoadedLevel", _descriptor, this);
    _initializerDefineProperty(this, "navigationCategories", _descriptor2, this);
    _initializerDefineProperty(this, "mostPopularSubcategories", _descriptor3, this);
    _initializerDefineProperty(this, "aggregatorIssuers", _descriptor4, this);
    _initializerDefineProperty(this, "aggregatorSubjects", _descriptor5, this);
    /**
     * The Learn AI navigation data for mobile nav.
     */
    _initializerDefineProperty(this, "aiLearningNav", _descriptor6, this);
    /**
     * Map of subcategory id to AI topics for that subcategory.
     */
    _initializerDefineProperty(this, "aiTopics", _descriptor7, this);
    this.loadNavigationCategories = async headerData => {
      if (!headerData.navigationCategories) {
        return;
      }
      const {
        user
      } = headerData;

      // Map header data to `navigateCategories` structure
      const navigationCategories = headerData.navigationCategories.map(({
        sd_tag: category,
        sublist
      }) => {
        // Build children from sublist categories
        const navigationCategoriesChildren = sublist.items.map(({
          sd_tag: subcategory
        }) => {
          // If user has a consumer subscription, exclude some subcategories
          if (user.consumer_subscription_active && SUBCATEGORY_NOT_IN_PERSONAL_PLAN.includes(subcategory.id)) {
            return null;
          }
          return {
            id: subcategory.id,
            parentId: category.id,
            title: subcategory.title,
            absolute_url: subcategory.url,
            type: BROWSE_TYPE.SUBCATEGORY
          };
        });
        const navigationCategory = {
          id: category.id,
          title: category.title,
          absolute_url: category.url,
          type: BROWSE_TYPE.CATEGORY,
          children: navigationCategoriesChildren.filter(Boolean)
        };
        return navigationCategory;
      });
      runInAction(() => {
        this.navigationCategories = navigationCategories;
      });
    };
    this.loadMostPopularTopicsForSubcategories = async locale => {
      const popularTopics = await fetchMostPopularTopicsForSubcategories(locale);
      const tempVariable = this.navigationCategories.reduce((acc, {
        children
      }) => [...acc, ...children], []).filter(({
        id
      }) => MOST_POPULAR_SUBCATEGORY_IDS.includes(id));
      const mostPopularSubcategories = tempVariable.map(mostPopularSubcategory => ({
        ...mostPopularSubcategory,
        popularTopics: popularTopics[mostPopularSubcategory.id]
      }));
      runInAction(() => {
        this.mostPopularSubcategories = mostPopularSubcategories;
      });
    };
    this.loadNavigationAggregatorTopics = async () => {
      var _aggregatorData$issue, _aggregatorData$subje;
      if (this.aggregatorIssuers || this.aggregatorSubjects) {
        return;
      }
      const aggregatorData = await fetchAggregatorTopics();
      function mapAggregatorData(category, type) {
        return {
          id: category.item.id,
          title: category.item.title,
          absolute_url: category.item.url,
          type: type,
          children: category.sub_items.map(subItem => {
            return {
              id: subItem.id,
              title: subItem.title,
              absolute_url: subItem.url,
              type: AggregatorNavItemType.TOPIC
            };
          })
        };
      }
      const aggregatorIssuers = aggregatorData === null || aggregatorData === void 0 || (_aggregatorData$issue = aggregatorData.issuers) === null || _aggregatorData$issue === void 0 ? void 0 : _aggregatorData$issue.map(issuer => {
        return mapAggregatorData(issuer, AggregatorNavItemType.CERTIFICATION_ISSUER_AGGREGATOR);
      });
      const aggregatorSubjects = aggregatorData === null || aggregatorData === void 0 || (_aggregatorData$subje = aggregatorData.subjects) === null || _aggregatorData$subje === void 0 ? void 0 : _aggregatorData$subje.map(issuer => {
        return mapAggregatorData(issuer, AggregatorNavItemType.CERTIFICATION_SUBJECT_AGGREGATOR);
      });
      runInAction(() => {
        this.aggregatorIssuers = aggregatorIssuers;
        this.aggregatorSubjects = aggregatorSubjects;
      });
    };
    /**
     * Loads the static Learn AI navigation data into the store and populates topics for each subcategory.
     */
    _initializerDefineProperty(this, "loadAiLearningNav", _descriptor8, this);
    this.lang = lang;
    this.gettext = gettext;
  }
  isLevelLoaded(level) {
    return level <= this.maxLoadedLevel;
  }
  ensureLevelIsLoaded(level) {
    this.maxLoadedLevel = Math.max(this.maxLoadedLevel, level);
  }
  /**
   * Fetches AI topics from GraphQL using the provided topic IDs.
   *
   * @param ids - Array of topic IDs to fetch
   * @returns Promise resolving to an array of topics with id, name, and url
   *
   * Example usage:
   *   const topics = await fetchAiTopicsWithGraphQL([123, 456]);
   */
  async fetchAiTopicsWithGraphQL(ids) {
    // Call the fetcher and await the response
    const gqlResponse = await useAiTopicsQuery.fetcher({
      ids
    })();
    // Defensive: handle missing or malformed response
    if (!gqlResponse || !gqlResponse.topics) {
      return [];
    }
    // Return the topics array
    return gqlResponse.topics.map(topic => ({
      id: Number(topic.id),
      title: topic.name,
      absolute_url: topic.url,
      type: BROWSE_TYPE.TOPIC
    }));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "maxLoadedLevel", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "navigationCategories", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "mostPopularSubcategories", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "aggregatorIssuers", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "aggregatorSubjects", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "aiLearningNav", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "aiTopics", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Map();
  }
}), _applyDecoratedDescriptor(_class.prototype, "ensureLevelIsLoaded", [action], Object.getOwnPropertyDescriptor(_class.prototype, "ensureLevelIsLoaded"), _class.prototype), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "loadAiLearningNav", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return async () => {
      var _rawNav$children, _aiLearningNav$childr;
      const rawNav = AI_LEARNING_NAV(this.gettext).AI_LEARNING;

      // Build the nav structure
      const aiLearningNav = {
        ...rawNav,
        absolute_url: 'none',
        children: (_rawNav$children = rawNav.children) === null || _rawNav$children === void 0 ? void 0 : _rawNav$children.map(subcategory => ({
          ...subcategory,
          absolute_url: 'none'
        }))
      };

      // Set the nav structure in an action
      runInAction(() => {
        this.aiLearningNav = aiLearningNav;
      });

      // Build subcategory to topic IDs map
      const subcategoryToTopicIds = {};
      (_aiLearningNav$childr = aiLearningNav.children) === null || _aiLearningNav$childr === void 0 || _aiLearningNav$childr.forEach(subcategory => {
        var _subcategory$title;
        // Use the slug field if it exists; otherwise, derive it from the title.
        const slug = subcategory.slug || ((_subcategory$title = subcategory.title) === null || _subcategory$title === void 0 ? void 0 : _subcategory$title.toString().toLowerCase().replace(/\s+/g, '-'));
        const category = aiTopicIdsByCategory.find(cat => cat.slug === slug);
        if (category) {
          subcategoryToTopicIds[subcategory.id] = category.ids;
        }
      });

      // Gather all unique topic IDs
      const allTopicIds = Array.from(new Set(Object.values(subcategoryToTopicIds).flat()));

      // Fetch topics asynchronously
      let fetchedTopics = [];
      try {
        fetchedTopics = await this.fetchAiTopicsWithGraphQL(allTopicIds);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Error fetching topics', e);
      }
      // Map topics by ID for quick lookup
      const topicsById = new Map(fetchedTopics.map(topic => [topic.id, topic]));

      // Mutate observables in an action
      runInAction(() => {
        Object.entries(subcategoryToTopicIds).forEach(([subcategoryId, topicIds]) => {
          const mappedTopics = topicIds.map(id => topicsById.get(Number(id))).filter(Boolean);
          this.aiTopics.set(Number(subcategoryId), mappedTopics);
        });
      });
    };
  }
}), _class);
//# sourceMappingURL=mobile-nav.mobx-store.js.map